import * as React from "react";
import ManyAdsFlowForm from "../../../components/Forms/MarketAdDefaultSetting/FlowForm/FlowForm";

export default function ManyAdsDefaultSettings() {
  return <ManyAdsFlowForm />;
}
